import { useDispatch } from "react-redux";
import { AppDispatch } from "store/store";
import { useRef } from "react";
import { DemoUsageType } from "../../../shared/enums/DemoUsageTypeEnum";
import Link from "../../../components/common/LinkButton";
import MSExcelExampleDrescription from "./MSExcelExampleDescription";
import PowerBIExampleDrescription from "./PowerBIExampleDescription";
import UrlHighlighter from "../UrlHighlighter";
import Highlighter from "../Highlighter";
import { DocsTab } from "../../../shared/enums/DocsTabEnum";
import { setSelectedIndex } from "../../../store/slices/DocsSlice";
import { useHistory } from "react-router";
import * as routePath from "shared/constants/RoutePathConstants";
import { H1, H2 } from "../Headings";
import ExternalLink from "../ExternalLink";
import DownloadExample from "./DownloadExample";

interface Props {
  logDownload : (demoId: string, usageType: DemoUsageType) => void; 
}

export default function ViewExamplesDescription(props: Props) {
  const dispatch = useDispatch<AppDispatch>();
  const history = useHistory();
  const { logDownload } = props;

  const MSExcelExampleDrescriptionRef = useRef(null);
  const PowerBIExampleDrescriptionRef = useRef(null);

  const scrollTo = (ref: any) => {
    ref.current.scrollIntoView();
  };

  const handleHowItWorksCLick = () => {
    dispatch(setSelectedIndex(DocsTab.HowItWorks));
  }

  const handleTokensCLick = () => {
    history.push(routePath.TOKENS);
  }

  const handleMoveToMSExcelSection = () => {
    scrollTo(MSExcelExampleDrescriptionRef);
  }

  const handleMoveToPowerBISection = () => {
    scrollTo(PowerBIExampleDrescriptionRef);
  }

  return(
    <div>
      <H1> View Examples </H1>
      <div>
        We’ve put together examples for you in {" "}
        <Link className="text-primaryRed" onClick={handleMoveToMSExcelSection}>
          MS Excel 
        </Link> {" "} and {" "}
        <Link className="text-primaryRed" onClick={handleMoveToPowerBISection}>
          MS Power BI 
        </Link> {" "} .<br/>
        This gives you the opportunity to experience the timePhasing service in its proper context. <br/>
        These examples are also provided in our interactive demo in the {" "} 
        <Link className="text-primaryRed" onClick={handleHowItWorksCLick}>
          How it works 
        </Link> 
        {" "}page.
      </div>

      <div className="mt-2">
        Read more about how to use the example files for Excel and Power BI in this page, or download files directly here:
      </div>

      <div className="py-4">
        <DownloadExample logDownload={logDownload}/>
      </div>

      <H2> Power Query </H2>
      <div>
        All examples utilize Microsoft Power Query to interact with the timePhasing service.
        To learn more about Power Query, please visit {" "}
          <ExternalLink url={"https://docs.microsoft.com/en-us/power-query/power-query-what-is-power-query"} />
        {" "} .
      </div>

      <div className="mt-4">
        <Highlighter isMultiLine>
          IMPORTANT NOTE: Power Query is embedded in Power BI and Microsoft Excel 365, 2021, 2019 and 2016. <br/>
          <UrlHighlighter
            method="If you are using Excel 2010 or 2013, add-in can be downloaded from Microsoft here: "
            link="https://www.microsoft.com/en-us/download/details.aspx?id=39379"
          />
        </Highlighter>
      </div>

      <div ref={MSExcelExampleDrescriptionRef}>
        <MSExcelExampleDrescription
          logDownload={logDownload}
          handleHowItWorksCLick={handleHowItWorksCLick}
          handleTokensCLick={handleTokensCLick}
        />
      </div>

      <div ref={PowerBIExampleDrescriptionRef}>
        <PowerBIExampleDrescription
          logDownload={logDownload}
          handleMoveToMSExcelSection={handleMoveToMSExcelSection}
          handleTokensCLick={handleTokensCLick}
        />
      </div>
      
    </div>
    
  );
}